const regexPattern = {
  phone: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
  abroadPhone: /^\d{5,12}$/,
  email: /^[A-Z0-9a-z._%+-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  account: /^[\w~!@#$%^&*()_\-+=[\]{}|\\;:'",./<>?]{6,200}$/,
  password: /^[\w~!@#$%^&*()_\-+=[\]{}|\\;:'",./<>?]{6,20}$/,
  companyName: /^[\u4e00-\u9fa5|(|)|（｜）]+$/, // 企业名称只允许中文和括号
}
export default regexPattern
